__turbopack_context__.v({
  "className": "landingsans_fc8b6f56-module__dyjNsW__className",
  "variable": "landingsans_fc8b6f56-module__dyjNsW__variable",
});
